// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"510":"e38ae4be","588":"b014590d"}[chunkId] + ".chunk.js";
};